import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { makeCollection } from '~data/selectors/collections'
import { makeStatus } from '~data/selectors/bookmarks'

import { HeaderTitle as TitleWrap, HeaderSpace as Space, Header } from '~ui'
import Icon from './icon'
import Title from './title'
import Open from './open'
import More from './more'
import Sort from './sort'
import View from './view'
import Export from '../../export/button'

export default function BookmarksHeader({ spaceId = 0, compact = false, ...etc }) {
    const getCollection = useMemo(() => makeCollection(), [])
    const getStatus = useMemo(() => makeStatus(), [])

    const collection = useSelector(state => getCollection(state, spaceId))
    const status = useSelector(state => getStatus(state, spaceId))

    const childProps = { ...etc, spaceId, compact, collection, status }

    return (
        <Header
            className={'ui-bm-header'}
            data-solid
            data-is-header>
            <Icon {...childProps} />

            <TitleWrap>
                <Title {...childProps} />
            </TitleWrap>

            <Open
                className={'ui-bm-hdr-open'}
                {...childProps} />

            <Space />

            <Sort {...childProps} />
            <View {...childProps} />
            {status.main == 'loaded' ? (
                <Export {...childProps} />
            ) : null}
            <More {...childProps} />
        </Header>
    )
}
